import { ConnectButton } from '@rainbow-me/rainbowkit'
import bg from './imgs/christmas_0.gif'
import fg from './imgs/land.jpg'
import dd from './imgs/DERP_TOKEN.png'
import React from 'react'
import Web3 from 'web3'
import { useAccount } from 'wagmi'
import { config } from './config'
import pendingGif from './imgs/pending2.gif'
import discord from './imgs/discord.png'
import tg from './imgs/icon--telegram.png'
import x from './imgs/icon--twitter.png'

const getTransactionReceipt = (hash, callback = () => {}) => {
    window.ethereum.request({
        method: "eth_getTransactionReceipt",
        params: [hash]
    }).then((res) => {
        if (res == null) {
            setTimeout(() => getTransactionReceipt(hash, callback), 2000)
        } else {
            callback(res)
        }
    }).catch((err) => {
        console.log(err)
        setTimeout(() => getTransactionReceipt(hash, callback), 2000)
    })
}

const web3 = new Web3(new Web3.providers.HttpProvider('https://rpc.soniclabs.com'));

export function Web3App(props) {
    const [pending, setIsPending] = React.useState(false)
    const [pendingText, setPendingText] = React.useState("Transaction is in process")
    const { address, isConnected } = useAccount()

    const [networkConfig] = React.useState(config["mainnet"])

    // Advent Calendar contract address
    const ADVENT_CALENDAR_ADDRESS = "0x4CfbDD76660252FBeCDab3afEEc2C3c9b6014CEE";

    // Advent Calendar ABI (only what we need)
    const adventCalendarAbi = [
        {
            "inputs": [],
            "name": "claimAllForUser",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "getCurrentDay",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "tokenId",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "day",
                    "type": "uint256"
                }
            ],
            "name": "canTokenClaimDay",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        }
    ];

    // Contract instances
    const derps = new web3.eth.Contract(networkConfig["derps"]["abi"], networkConfig["derps"]["address"])
    const adventCalendar = new web3.eth.Contract(adventCalendarAbi, ADVENT_CALENDAR_ADDRESS);

    // State
    const [derpBalance, setDerpBalance] = React.useState(0);
    const [currentDay, setCurrentDay] = React.useState(0);
    const [hasClaimableGifts, setHasClaimableGifts] = React.useState(false);
    const [statusMessage, setStatusMessage] = React.useState("Connect your wallet");
    const [isLoading, setIsLoading] = React.useState(false);

    // SIMPLE CHECK: Check if ANY token can claim ANY day
    const checkForClaimableGifts = async () => {
        if (!address || !adventCalendar || !derps) return false;
        
        setIsLoading(true);
        setStatusMessage("Checking for gifts...");
        
        try {
            // 1. Get current day
            const currentDayNum = await adventCalendar.methods.getCurrentDay().call();
            const day = Number(currentDayNum);
            setCurrentDay(day);
            
            if (day < 1) {
                setStatusMessage("Advent calendar hasn't started yet");
                setHasClaimableGifts(false);
                setIsLoading(false);
                return false;
            }
            
            // 2. Get user's Derp balance
            const balance = await derps.methods.balanceOf(address).call({ from: address });
            const bal = Number(balance);
            setDerpBalance(bal);
            
            if (bal === 0) {
                setStatusMessage("You don't own any Derps");
                setHasClaimableGifts(false);
                setIsLoading(false);
                return false;
            }
            
            // 3. Get token IDs
            const tokenIdPromises = [];
            for (let i = 0; i < bal; i++) {
                tokenIdPromises.push(derps.methods.tokenOfOwnerByIndex(address, i).call({ from: address }));
            }
            const tokenIds = await Promise.all(tokenIdPromises);
            const ids = tokenIds.map(id => Number(id));
            
            // 4. Check yesterday and today for ANY token
            const daysToCheck = [];
            if (day >= 2) {
                daysToCheck.push(day);      // Today
                daysToCheck.push(day - 1);  // Yesterday
            } else if (day === 1) {
                daysToCheck.push(1);        // Day 1 only
            }
            
            // 5. Check ALL tokens against ALL days
            let foundClaimable = false;
            
            for (const tokenId of ids) {
                for (const dayToCheck of daysToCheck) {
                    try {
                        const canClaim = await adventCalendar.methods.canTokenClaimDay(tokenId, dayToCheck).call({ from: address });
                        
                        if (canClaim) {
                            foundClaimable = true;
                            break; // Found one, no need to check more
                        }
                    } catch (err) {
                        console.log(`Error checking day ${dayToCheck}:`, err);
                    }
                }
                if (foundClaimable) break; // Found one, no need to check more tokens
            }
            
            // 6. Update state
            setHasClaimableGifts(foundClaimable);
            
            if (foundClaimable) {
                setStatusMessage("🎁 Gifts available to claim!");
            } else {
                setStatusMessage("No gifts available to claim right now");
            }
            
            setIsLoading(false);
            return foundClaimable;
            
        } catch (error) {
            console.error("Error checking gifts:", error);
            setStatusMessage("Error checking for gifts");
            setHasClaimableGifts(false);
            setIsLoading(false);
            return false;
        }
    };

    const sendRequest = (contract, data, callback = () => {}) => {
        setIsPending(true);
        setIsLoading(true);
        setPendingText("Claiming gifts...");

        if (typeof window.ethereum !== 'object') {
            alert("Please install MetaMask");
            setIsPending(false);
            setIsLoading(false);
            return;
        }

        window.ethereum.request({
            method: "eth_sendTransaction",
            params: [{
                from: address,
                to: contract,
                value: '0x0',
                data: data,
            }],
        }).then((hash) => {
            getTransactionReceipt(hash, (receipt) => {
                setIsPending(false);
                setIsLoading(false);
                
                if (receipt && receipt.status === "0x1") {
                    setStatusMessage("🎉 Successfully claimed gifts!");
                    setTimeout(() => checkForClaimableGifts(), 3000); // Refresh status
                    callback();
                } else {
                    setStatusMessage("Transaction failed");
                }
            });
        }).catch((err) => {
            console.error("Transaction error:", err);
            setIsPending(false);
            setIsLoading(false);
            setStatusMessage("Transaction failed");
        });
    };

    const claimAllGifts = async () => {
        if (!address || !hasClaimableGifts) return;
        
        try {
            const data = adventCalendar.methods.claimAllForUser().encodeABI();
            sendRequest(ADVENT_CALENDAR_ADDRESS, data);
        } catch (error) {
            console.error("Error preparing claim:", error);
            setStatusMessage("Error preparing claim");
        }
    };

    // Load when address changes
    React.useEffect(() => {
        if (address) {
            checkForClaimableGifts();
            
            // Refresh every 30 seconds
            const interval = setInterval(() => {
                if (address && !pending && !isLoading) {
                    checkForClaimableGifts();
                }
            }, 30000);
            
            return () => clearInterval(interval);
        } else {
            // Reset when disconnected
            setDerpBalance(0);
            setCurrentDay(0);
            setHasClaimableGifts(false);
            setStatusMessage("Connect your wallet");
            setIsLoading(false);
        }
    }, [address]);

    return (
        <div className={"App App--" + isConnected}>
            <div className="bg" style={{ backgroundImage: `url(${bg})` }}>
                <div className="action-grid">
                    <div className="grid-item grid-item--main">
                        <h2>Derp Advent Calendar</h2>
                        <div className="grid-item-inner">
                            <p>Merry Christmas!</p>
                            <p>Prizes for participants will be distributed on 12/27</p>
                            <p>Users that claimed every item (8 users) will receive a derp.</p>
                            <p>All other particpants will receive an Uppies Meal.</p>
                        </div>
                    </div>
                </div>

                <div className="dd"><img src={dd} alt="Derp Token" /></div>

                <div className="links">
                    <a href="https://my.derpe.xyz" target="_blank" rel="noreferrer">View</a>
                   
                    <a href="https://discord.gg/3BUen4F9Tw" target="_blank" rel="noreferrer"><img src={discord} alt="Discord" /></a>
                    <a href="https://t.me/derpedewdz" target="_blank" rel="noreferrer"><img src={tg} alt="Telegram" /></a>
                    <a href="https://x.com/derpedewdz" target="_blank" rel="noreferrer"><img src={x} alt="Twitter" /></a>
                </div>

                <div className="connect-button">
                    <div className="inliner docs"><a href="https://docs.derpe.xyz" target="_blank" rel="noreferrer">DOCS</a></div>
                    <div className="inliner"><ConnectButton /></div>
                </div>

                <div className={`pending pending--${pending}`}>
                    <p className="pending-title">Transaction Pending</p>
                    <p className="pending-text">{pendingText}</p>
                    <div className="pending-gif"><img src={pendingGif} alt="Pending" /></div>
                </div>
            </div>
        </div>
    );
}